// Commands file for ribbon button actions
// This runs when user clicks ribbon buttons that don't open the taskpane

Office.onReady(() => {
  // Register the generateDraft function for the ribbon button
});

// Function called when user clicks "Generate Draft" button in ribbon
function generateDraft(event: Office.AddinCommands.Event) {
  // For now, just show a notification - full implementation will open taskpane
  Office.context.mailbox.item?.notificationMessages.addAsync('generate-draft', {
    type: Office.MailboxEnums.ItemNotificationMessageType.InformationalMessage,
    message: 'Opening AutoResponder panel...',
    icon: 'icon-16',
    persistent: false,
  });

  // Signal completion
  event.completed();
}

// Register the function globally so Office.js can find it
(globalThis as unknown as Record<string, unknown>).generateDraft = generateDraft;
